import { Box, Typography, Avatar, Container } from "@mui/material";
import Slider from "react-slick";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Blog } from "../../assets";
const SlickSlider = Slider as unknown as React.FC<any>;

const testimonials = [
    {
        name: 'Mallareddy Putluri',
        image: Blog.bloguser,
        text: "I am so happy to say that ' Working with Mr. Rajiv Williams is constant experience for me of course for everyone. Every day He always teaches new things like skill, perspective and many more. he always says in the morning everyday that *DO IT WITH YOUR PASSION AND HEART OR ELSE DONT DO IT* . His deducation and work inspire everyone to give our best always. Having a mentor like him makes you perfect interms of tasks,learning,improving skills,focus about your work and life too.",
    },
    {
        name: 'Sandeep Kylas',
        image: Blog.bloguser,
        text: "I had the privilege of consulting with Rajiv for a real estate matter in the Hyderabad area, and I couldn't have asked for a better advisor. Rajiv's deep understanding of the local market dynamics and his insightful guidance gave us a very good perspective on potential opportunities in Hyderabad. I wholeheartedly recommend Rajiv to anyone seeking expert real estate consultation in Hyderabad/Telangana.",
    },
    {
        name: 'Mohammed Safiuddin',
        image: Blog.bloguser,
        text: 'I had the pleasure of being mentored by Mr Rajiv Williams in developing my interpersonal skills . His expertise and guidance were instrumental in my professional growth. He provides valuable insights, pushed me to expand my skills, and always made time to offer support and advice.Thank you so much .By far you are the best mentor i have ever came across.',
    },
    {
        name: 'Arun K Gattu',
        image: Blog.bloguser,
        text: "I've known Rajiv for a long time, and when it comes to real estate, he's the guy you want in your corner. Need market insights? He's got them. Looking for the best deals? He knows where to find them. Have a real estate query at midnight? Don’t be surprised if he replies in seconds! What makes Rajiv stand out is not just his deep industry knowledge but also his cool, no-stress approach. He simplifies things, gives honest advice, and always delivers with speed and clarity. If real estate is on your mind, Rajiv is the one to call!",
    },
    {
        name: 'Sumanth Reddy Arani',
        image: Blog.bloguser,
        text: 'Rajiv is exceptional in what he does and consistently goes above and beyond to deliver outstanding results to ensure the success of the projects. His enthusiasm, attention to detail, excellent communication skills, and ability to adapt make him a valuable asset to any organization. Moreover, Rajiv is a quick learner who embraces new technologies and industry trends. He consistently stays up to date with the latest advancements, bringing innovative ideas and fresh perspectives to the table. ',
    },
];

const NextArrow = ({ onClick }: any) => (
    <Box
        onClick={onClick}
        sx={{
            position: "absolute",
            right: "-25px",
            top: "50%",
            transform: "translateY(-50%)",
            zIndex: 5,
            background: "#fff",
            width: 40,
            height: 40,
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
        }}
    >
        <ArrowForwardIos sx={{ color: "#0f63a5", fontSize: 18 }} />
    </Box>
);

const PrevArrow = ({ onClick }: any) => (
    <Box
        onClick={onClick}
        sx={{
            position: "absolute",
            left: "-25px",
            top: "50%",
            transform: "translateY(-50%)",
            zIndex: 5,
            background: "#fff",
            width: 40,
            height: 40,
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
        }}
    >
        <ArrowBackIos sx={{ color: "#0f63a5", fontSize: 18 }} />
    </Box>
);

const TestimonialsSlider = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 800,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3500,
        arrows: true,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,

        centerMode: false, // ❌ disable this if enabled
        variableWidth: false, // ❌ IMPORTANT FIX

        responsive: [
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    };

    return (
        <Box sx={{ py: 12, color: "#fff" }}>
            <Container maxWidth="lg">

                {/* HEADING */}
                <Typography
                variant="h3"
                    textAlign="center"
                    sx={{

                        // fontSize: { xs: "2rem", md: "3rem" },
                        letterSpacing: "4px",
                        mb: 8,
                        color:"white"
                    }}
                >
                    CLIENT SUCCESS STORIES
                </Typography>

                {/* SLIDER */}
                <Box
                    sx={{
                        position: "relative",

                        "& .slick-slide": {
                            padding: "0 16px", // 🔥 spacing between cards
                            boxSizing: "border-box",
                        },

                        "& .slick-list": {
                            margin: "0 -16px", // 🔥 fixes outer gap
                        },
                        "& .slick-prev:before, & .slick-next:before": {
                            display: "none",
                        },

                        // 🔥 DOTS
                        "& .slick-dots li button:before": {
                            color: "#fff",
                            opacity: 0.6,
                        },
                        "& .slick-dots li.slick-active button:before": {
                            opacity: 1,
                        },
                    }}
                >
                    <SlickSlider {...settings}>
                        {testimonials.map((item, index) => (
                            <Box key={index} sx={{ height: "100%" }}>

                                <Box
                                    sx={{
                                        p: 4,
                                        borderRadius: "16px",
                                        background: "rgba(255,255,255,0.05)",
                                        backdropFilter: "blur(8px)",
                                        border: "1px solid rgba(212,175,55,0.25)",
                                        height: { xs: "auto", md: "300px" },
                                        display: "flex",                 // 🔥 IMPORTANT
                                        flexDirection: "column",         // 🔥 IMPORTANT
                                        justifyContent: "space-between", // 🔥 PUSHES USER TO BOTTOM

                                        transition: "0.4s",

                                        "&:hover": {
                                            // transform: "translateY(-6px)",
                                            borderColor: "#d4af37",
                                        },
                                    }}
                                >
                                    {/* TEXT */}
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            textAlign: 'start',
                                            mb: 4,
                                            lineHeight: 1.8,
                                            color: 'white'
                                        }}
                                    >
                                        “{item.text}”
                                    </Typography>

                                    {/* USER */}
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            mt: 3, // spacing from text
                                        }}
                                    >
                                        <Avatar
                                            src={item.image}
                                            sx={{
                                                width: 50,
                                                height: 50,
                                                mr: 2,
                                            }}
                                        />

                                        <Typography fontWeight={600} sx={{ color: "white" }}>
                                            {item.name}
                                        </Typography>
                                    </Box>
                                </Box>

                            </Box>
                        ))}
                    </SlickSlider>
                </Box>

            </Container>
        </Box>
    );
};

export default TestimonialsSlider;